// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".separation-of-funds .label[data-v-c657db40] {\n  font-weight: normal;\n  font-size: 0.875rem;\n  color: #727272;\n}\n.separation-of-funds .info[data-v-c657db40] {\n  font-weight: normal;\n  color: #11291B;\n}\n.separation-of-funds .separation-of-funds__separator[data-v-c657db40] .separator-custom {\n  --background-color-active: #b5c3bc;\n  --line-separator-color: #b5c3bc;\n  font-size: 0.875rem;\n}\n[data-v-c657db40] .dot {\n  padding: 15px 13px 15px 15px;\n}", ""]);
// Exports
module.exports = exports;
